/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CittadinoAssistenzaForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface InviaAssistenzaCittadinoRequestParams {
    cittadinoAssistenzaForm: CittadinoAssistenzaForm;
    gestioneMenseServizioId?: string;
}


export interface CittadinoAssistenzaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Invia messaggio di assistenza
     * Audience: CITTADINO. Due rami mutuamente esclusivi: ramo servizio (studente_id + header Gestione-Mense-Servizio-Id, destinatario ServizioMensa.assistenzaEmail) oppure ramo comune (slug_comune, destinatario Comune.email). Esattamente uno dei due selettori; messaggio sempre obbligatorio. From comune-aware (mai l\&#39;email del cittadino), Reply-To &#x3D; email del form o dell\&#39;utente. Il campo opzionale cellulare, se valorizzato, e\&#39; riportato nel corpo dell\&#39;email come numero per il ricontatto telefonico.
     * @endpoint post /api/v1/cittadino/servizi/assistenza
* @param requestParameters
     */
    inviaAssistenzaCittadino(requestParameters: InviaAssistenzaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

}
